import React, { useState } from "react"
import RaffleHolder from "./RaffleHolder"
import Button from "./Button"
import { useRaffle } from "../RaffleContext"
import { usePiano } from "../../Piano"
import I18n from "@helper/i18nInstance"
import "./RaffleOpen.scss"
import { useRaffleErrorMsg } from ".."
import ErrorMsg from "./ErrorMsg"
import Checkbox from "./Checkbox"

const RaffleOpen: React.FC = () => {
  const {
    userInfo
  } = usePiano()
  const {
    actionParticipate,
    disableParticipateButton,
    raffle,
  } = useRaffle()
  const errorMsg = useRaffleErrorMsg()
  const [ termsState, setTermsState ] = useState({ selected: false, error: false })

  const loggedIn = !!userInfo?.user

  const onParticipate = () => {
    if (termsState.selected) {
      actionParticipate()
    } else {
      setTermsState((prev) => ({...prev, error: true}))
    }
  }

  const multilineLoginOrRegisterLabel = I18n.t("raffle.action_login_or_register").split(", ").join(",<br>")

  return <RaffleHolder testId="raffle-open">
    {loggedIn
      ? <div dangerouslySetInnerHTML={{__html: I18n.t("raffle.info_accept_terms--loggedIn", {username: `<strong>${userInfo.user.email}</strong>`})}} />
      : <div>{I18n.t("raffle.info_accept_terms--notLoggedIn")}</div>}
    <Checkbox
      selected={termsState.selected}
      onChange={(val) => setTermsState((prev) => val ? { selected: true, error: false } : { selected: false, error: prev.error })}
      error={termsState.error ? I18n.t("raffle.error.accept_terms") : undefined}
      label={raffle?.meta.accept_terms_html || ""} />
    <div className="neo__raffleOpen__actionHolder">
      <Button onPress={onParticipate} disabled={disableParticipateButton} labelWithHTML={loggedIn ? I18n.t("raffle.action_participate") : multilineLoginOrRegisterLabel} />
    </div>
    {errorMsg && <div className="neo__raffleOpen__errorHolder"><ErrorMsg>{errorMsg}</ErrorMsg></div>}
  </RaffleHolder>
}

export default RaffleOpen
